import { useState, useEffect } from 'react'
import styles from './HeroBanner.module.css'
import { API_BASE_URL, getImageUrl } from '../config'

interface HomeConfig {
  hero_title: string
  hero_subtitle: string
  logo_url: string
  background_url: string
}

interface HeroBannerProps {
  onLogoClick?: () => void
}

const HeroBanner = ({ onLogoClick }: HeroBannerProps) => {
  const [config, setConfig] = useState<HomeConfig | null>(null)

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/home/config`)
        const result = await response.json()
        if (result.success) {
          setConfig(result.data)
        }
      } catch (error) {
        console.error('Failed to fetch home config:', error)
      }
    }
    fetchConfig()
  }, [])

  return (
    <div className={styles.hero} style={config?.background_url ? { backgroundImage: `url('${getImageUrl(config.background_url)}')` } : undefined}>
      <div className={styles.overlay}></div>
      <div className={styles.logoContainer} onClick={onLogoClick}>
        {config?.logo_url ? (
          <img src={getImageUrl(config.logo_url)} alt="Antom" className={styles.logo} />
        ) : (
          <img src="/images/footer-logo.png" alt="Antom" className={styles.logo} />
        )}
      </div>
      <div className={styles.content}>
        <h1 className={styles.title}>{config?.hero_title || '千里智行 始于支付'}</h1>
        <p className={styles.subtitle}>{config?.hero_subtitle || '蚂蚁国际旗下商户支付和数字化服务品牌'}</p>
      </div>
      <div className={styles.decoration}></div>
    </div>
  )
}

export default HeroBanner